import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _683a050e = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _fd668db2 = () => interopDefault(import('../pages/game/index.vue' /* webpackChunkName: "pages/game/index" */))
const _6f22adea = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _38aa4a4a = () => interopDefault(import('../pages/game/components/answer-splash/index.vue' /* webpackChunkName: "pages/game/components/answer-splash/index" */))
const _fdf19300 = () => interopDefault(import('../pages/game/components/answers-bar/index.vue' /* webpackChunkName: "pages/game/components/answers-bar/index" */))
const _f4bb4f3c = () => interopDefault(import('../pages/game/components/basic-game/index.vue' /* webpackChunkName: "pages/game/components/basic-game/index" */))
const _b35e82ac = () => interopDefault(import('../pages/game/components/cancel-game/index.vue' /* webpackChunkName: "pages/game/components/cancel-game/index" */))
const _211eac9c = () => interopDefault(import('../pages/game/components/correct-answer/index.vue' /* webpackChunkName: "pages/game/components/correct-answer/index" */))
const _fedbd9fc = () => interopDefault(import('../pages/game/components/game-intro/index.vue' /* webpackChunkName: "pages/game/components/game-intro/index" */))
const _458a7b53 = () => interopDefault(import('../pages/game/components/level-complete/index.vue' /* webpackChunkName: "pages/game/components/level-complete/index" */))
const _606802b8 = () => interopDefault(import('../pages/game/components/progress-bar/index.vue' /* webpackChunkName: "pages/game/components/progress-bar/index" */))
const _4c6a6552 = () => interopDefault(import('../pages/game/components/question/index.vue' /* webpackChunkName: "pages/game/components/question/index" */))
const _0c49c57a = () => interopDefault(import('../pages/game/components/sound-toggle/index.vue' /* webpackChunkName: "pages/game/components/sound-toggle/index" */))
const _06764b82 = () => interopDefault(import('../pages/game/components/trophies/index.vue' /* webpackChunkName: "pages/game/components/trophies/index" */))
const _0385c3cf = () => interopDefault(import('../pages/login/components/delete-user/index.vue' /* webpackChunkName: "pages/login/components/delete-user/index" */))
const _399ddd90 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _683a050e,
    name: "about"
  }, {
    path: "/game",
    component: _fd668db2,
    name: "game"
  }, {
    path: "/login",
    component: _6f22adea,
    name: "login"
  }, {
    path: "/game/components/answer-splash",
    component: _38aa4a4a,
    name: "game-components-answer-splash"
  }, {
    path: "/game/components/answers-bar",
    component: _fdf19300,
    name: "game-components-answers-bar"
  }, {
    path: "/game/components/basic-game",
    component: _f4bb4f3c,
    name: "game-components-basic-game"
  }, {
    path: "/game/components/cancel-game",
    component: _b35e82ac,
    name: "game-components-cancel-game"
  }, {
    path: "/game/components/correct-answer",
    component: _211eac9c,
    name: "game-components-correct-answer"
  }, {
    path: "/game/components/game-intro",
    component: _fedbd9fc,
    name: "game-components-game-intro"
  }, {
    path: "/game/components/level-complete",
    component: _458a7b53,
    name: "game-components-level-complete"
  }, {
    path: "/game/components/progress-bar",
    component: _606802b8,
    name: "game-components-progress-bar"
  }, {
    path: "/game/components/question",
    component: _4c6a6552,
    name: "game-components-question"
  }, {
    path: "/game/components/sound-toggle",
    component: _0c49c57a,
    name: "game-components-sound-toggle"
  }, {
    path: "/game/components/trophies",
    component: _06764b82,
    name: "game-components-trophies"
  }, {
    path: "/login/components/delete-user",
    component: _0385c3cf,
    name: "login-components-delete-user"
  }, {
    path: "/",
    component: _399ddd90,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
